/*
 * Author: GM
 * Component: dxDataSource
 */

!function ($) {
    "use strict";

    $.dxLookup = {
        groupProperties: function () {
            return {
                allowClearing: true,
                valueExpr: "Id",
                displayExpr: "Property",
                dataSource: $.dxDataSource.groupProperties({
                    key: 'Id',
                    keyType: 'Int32',
                    loadMode: 'raw'
                })
            }
        }
    };

    $.dxColumn = {

        DefaultText: function (dataField, caption, options) {
            return $.extend({
                caption: caption,
                dataField: dataField,
                allowSorting: false,
                allowFiltering: false,
                allowHeaderFiltering: false
            }, options);
        },

        DefaultId: function (dataField, calculateDisplayValue, caption, options) {
            return $.extend({
                caption: caption,
                dataField: dataField,
                allowSorting: false,
                allowFiltering: false,
                allowHeaderFiltering: false,
                calculateDisplayValue: calculateDisplayValue,
                alignment: 'left'
            }, options);
        },

        Virtual: function (caption, calculateDisplayValue) {
            return this.DefaultText(undefined, caption, {
                caption: caption,
                calculateDisplayValue: calculateDisplayValue
            });
        },

        Id: function (dataField, caption, cellTemplate, options) {
            return $.extend({
                caption: caption,
                dataField: dataField,
                allowSorting: false,
                allowFiltering: false,
                allowHeaderFiltering: false,

                filterOperations: ["="],
                cellTemplate: cellTemplate
            }, options);
        },



        Money: function (dataField, caption, options) {
            return $.extend({
                caption: caption,
                dataField: dataField,
                dataType: 'number',
                calculateDisplayValue: function (rowData) {

                    return DisplayToMoney(rowData['Currency'], rowData[dataField]);
                },
                calculateCellValue: function (rowData) {

                    return ToCurrency(rowData[dataField]);
                },
                calculateFilterExpression: function (filterValue, selectedFilterOperation) {

                    if (selectedFilterOperation === "between" && $.isArray(filterValue)) {
                        return [
                            [this.dataField, ">", FromCurrency(filterValue[0])],
                            "and",
                            [this.dataField, "<", FromCurrency(filterValue[1])]
                        ];
                    }

                    return [this.dataField, selectedFilterOperation, FromCurrency(filterValue)];
                }
            }, options);
        },

        DateTime: function (dataField, caption, options) {
            return $.extend({
                dataField: dataField,
                caption: caption,
                dataType: "date",
                format: "dd.MM.yyyy HH:mm"
            }, options);
        },

        Date: function (dataField, caption, options) {
            return $.extend({
                dataField: dataField,
                caption: caption,
                dataType: "date",
                format: "dd.MM.yyyy"
            }, options);
        },

        CreateDate: function (caption, options) {
            return this.DateTime('CreateDate', caption, options);
        }
    }


    var dxDataSource = function () {
        console.log('dxDataSource.Constructor');
    };

    dxDataSource.prototype.getOptions = function (options) {
        options = $.extend({
            key: "Id",
            loadMethod: "POST"
        }, options);

        console.log('createStore.options', options);
        return options;
    }

    dxDataSource.prototype.createStore = function (options) {
        return DevExpress.data.AspNet.createStore(this.getOptions(options));
    }

    dxDataSource.prototype.groupProperties = function (options) {
        return this.createStore($.extend({
            loadUrl: Ul('ajaxDataSource/groupProperties')
        }, options));
    };

    dxDataSource.prototype.groupReservations = function (options) {
        return this.createStore($.extend({
            loadUrl: Ul('ajaxDataSource/groupReservations')
        }, options));
    };

    dxDataSource.prototype.propertyReservations = function (propertyId) {
        return this.createStore({
            loadUrl: Ul('ajaxDataSource/propertyReservations/' + propertyId)
        });
    };

    $.dxDataSource = new dxDataSource;
    $.dxDataSource.Constructor = dxDataSource;
}(window.jQuery);


